export default "__VITE_ASSET__bdd362f1__"